'use client';

import {
  CUSTOMER_CREDIT_TYPES,
  getCustomerCreditBalance,
} from '@eliadmin/core/src/api/customers/customer-credit-utils';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';

/**
 * The customer's loyalty points and what they are worth – the source of the core profile and cart
 * (`profile-loyalty-program-balance.tsx`): the store's loyalty program from the layout and the
 * `loyalty_points` credit balance of the customer. `null` without a loyalty program or without
 * points, so the sidebar shows no invented (or empty) box.
 */
export function useLoyalty() {
  const program = useGlobalStore(s => s.generalLayout.loyalty_program);
  const currency = useGlobalStore(s => s.generalLayout.currency);
  const currencySettings = useGlobalStore(s => s.generalLayout.currency_settings);
  const customer = useCustomerStore(s => s.me?.customer);
  const locale = useLocaleStore(s => s.currentLocale);
  if (!program || !customer) return null;

  const balance = Number(
    getCustomerCreditBalance(customer, CUSTOMER_CREDIT_TYPES.LOYALTY_POINTS) ?? 0,
  );
  const points = Number.isFinite(balance) ? balance : 0;
  if (points <= 0) return null;
  const value = points * Number(program.point_to_currency ?? 0);

  return {
    points,
    /** „1 240“ */
    formattedPoints: new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(points),
    /** „12,40 €“ – store format */
    value: formatPrice(value, currency, currencySettings),
  };
}
